import { DateTime } from '@ksyos/date-time';
import type { IDataRequest } from '../../../common/utils/IDataRequest';
import { ContentType } from '../../../common/enums/ContentType';
import { DataRequestStatus } from '../../../common/enums/DataRequestStatus';
import { fetchJson } from '../../store/fetch';

export async function getDossierUrl() {
    const postDataRequestResult = await fetchJson('/api/dataRequests', 'POST', { format: ContentType.applicationPdf });
    if (!postDataRequestResult?.json?.id) {
        throw new Error('Failed to create data request');
    }

    const dataRequestsResult = await fetchJson('/api/dataRequests', 'GET');
    if (!dataRequestsResult?.json?.items) {
        throw new Error('Failed to fetch data requests');
    }

    const dataRequests: IDataRequest[] = dataRequestsResult.json.items;
    const oneWeekAgo = DateTime.now().subtract(7, 'days');

    const currentPdfRequest = dataRequests.find(
        (request: IDataRequest) =>
            request.format === ContentType.applicationPdf &&
            (request.status === DataRequestStatus.open ||
                (request.status === DataRequestStatus.processed &&
                    request.fileProcessedAt &&
                    DateTime.from(request.fileProcessedAt).isAfter(oneWeekAgo)))
    );

    if (!currentPdfRequest) {
        throw new Error('Failed to find current data request');
    }

    if (currentPdfRequest.status !== DataRequestStatus.processed) {
        throw new Error('Data request is not processed');
    }

    return `/api/dataRequests/${currentPdfRequest.id}?format=${encodeURIComponent(ContentType.applicationPdf)}`;
}
